import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';
import { publishAppToast } from '../../utils/appToast';
import { registerSessionExpiredHandler } from '../../utils/authSession';

export default function SessionExpiredListener() {
  const { logout } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    registerSessionExpiredHandler(() => {
      publishAppToast('Your session has expired. Please login again.', 'error');
      logout();
      navigate(ROUTES.HOME, { replace: true });
    });

    return () => registerSessionExpiredHandler(null);
  }, [logout, navigate]);

  return null;
}
